import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import CircularProgress from '@material-ui/core/CircularProgress';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import Chip from '@material-ui/core/Chip';
import { validateWorkspace } from '../../services/admin-billing.service';

class WorkspaceValidator extends Component {
    constructor(props) {
        super(props);
        this.state = {
            validating: false,
            isValid: null,
            errorMessage: '',
            suggestions: [],
        };
        this.debounceTimer = null;
    }

    componentWillUnmount() {
        if (this.debounceTimer) clearTimeout(this.debounceTimer);
    }

    generateSuggestions(base) {
        const clean = base.replace(/[^a-z0-9]/g, '');
        if (clean.length < 2) return [];
        const rand = () => Math.floor(Math.random() * 900) + 100;
        return [
            `${clean}-${rand()}`,
            `${clean}-app`,
            `${clean}-${new Date().getFullYear()}`,
        ];
    }

    handleChange = (e) => {
        const value = e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, '');

        if (this.props.onChange) {
            this.props.onChange(value);
        }

        if (this.debounceTimer) clearTimeout(this.debounceTimer);

        if (value.length < 3) {
            this.setState({ isValid: null, validating: false, errorMessage: '', suggestions: [] });
            if (this.props.onValidation) this.props.onValidation(false);
            return;
        }

        this.setState({ validating: true, suggestions: [] });

        this.debounceTimer = setTimeout(() => {
            validateWorkspace(value)
                .then(result => {
                    const available = result.data && result.data.data && result.data.data.available;
                    const suggestions = available ? [] : this.generateSuggestions(value);
                    this.setState({
                        validating: false,
                        isValid: available,
                        errorMessage: available ? '' : 'Workspace ja esta em uso. Sugestoes:',
                        suggestions,
                    });
                    if (this.props.onValidation) this.props.onValidation(available);

                    // Validar sugestões em background
                    if (!available && suggestions.length > 0) {
                        this.validateSuggestions(suggestions);
                    }
                })
                .catch(() => {
                    this.setState({
                        validating: false,
                        isValid: false,
                        errorMessage: 'Erro ao validar workspace',
                        suggestions: [],
                    });
                    if (this.props.onValidation) this.props.onValidation(false);
                });
        }, 500);
    }

    validateSuggestions = async (suggestions) => {
        const validSuggestions = [];
        for (const s of suggestions) {
            try {
                const r = await validateWorkspace(s);
                if (r.data?.data?.available) validSuggestions.push(s);
            } catch { /* ignore */ }
        }
        this.setState({ suggestions: validSuggestions.length > 0 ? validSuggestions : suggestions });
    }

    handleSuggestionClick = (suggestion) => {
        if (this.props.onChange) {
            this.props.onChange(suggestion);
        }
        // Re-validate
        this.setState({ validating: true, suggestions: [] });
        validateWorkspace(suggestion)
            .then(result => {
                const available = result.data?.data?.available;
                this.setState({
                    validating: false,
                    isValid: available,
                    errorMessage: available ? '' : 'Workspace ja esta em uso',
                    suggestions: [],
                });
                if (this.props.onValidation) this.props.onValidation(available);
            })
            .catch(() => {
                this.setState({ validating: false, isValid: false, errorMessage: 'Erro ao validar' });
                if (this.props.onValidation) this.props.onValidation(false);
            });
    }

    render() {
        const { value, label, required, disabled } = this.props;
        const { validating, isValid, errorMessage, suggestions } = this.state;

        let endAdornment = null;
        if (validating) {
            endAdornment = <InputAdornment position="end"><CircularProgress size={20} /></InputAdornment>;
        } else if (isValid === true) {
            endAdornment = <InputAdornment position="end"><CheckCircleIcon style={{ color: '#4caf50' }} /></InputAdornment>;
        } else if (isValid === false) {
            endAdornment = <InputAdornment position="end"><ErrorIcon style={{ color: '#f44336' }} /></InputAdornment>;
        }

        return (
            <div>
                <TextField
                    label={label || 'Workspace'}
                    value={value || ''}
                    onChange={this.handleChange}
                    fullWidth
                    required={required}
                    disabled={disabled}
                    error={isValid === false}
                    helperText={errorMessage || 'Apenas letras minusculas, numeros e hifens'}
                    InputProps={{ endAdornment }}
                />
                {suggestions.length > 0 && (
                    <div style={{ marginTop: 6, display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                        {suggestions.map(s => (
                            <Chip
                                key={s}
                                label={s}
                                size="small"
                                clickable
                                color="primary"
                                variant="outlined"
                                onClick={() => this.handleSuggestionClick(s)}
                                style={{ cursor: 'pointer' }}
                            />
                        ))}
                    </div>
                )}
            </div>
        );
    }
}

export default WorkspaceValidator;
